import { render } from "./InputRadio.vue?vue&type=template&id=137f16e3&scoped=true"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"

import "./InputRadio.vue?vue&type=style&index=0&id=137f16e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137f16e3"]])

export default __exports__